import React, { useRef, useState } from "react";
import { BackButton } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import FileUploadChoose from "../../../commons/FileUploadChoose";
import { useDispatch, useSelector } from "react-redux";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";
import { uploadFile } from "../../../redux/uploadFile/slice";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputError } from "../../../commons/MicroComponents";
import FileView from "../components/FileView";

const ApplyingForPasses = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Validation
  const validationSchema = Yup.object().shape({
    type_of_pass: Yup.object().nullable().required("Type Of Pass is required"),
    ic_front: Yup.mixed().required("IC Front is required"),
    ic_back: Yup.mixed().required("IC Back is required"),
    resume: Yup.mixed().required("Resume is required"),
    passport: Yup.mixed().required("Passport is required"),
    education_certificate: Yup.mixed().required(
      "Education Certificate is required"
    ),
    marriage_birth_certificate: Yup.mixed().when("type_of_pass", {
      is: (type_of_pass) => type_of_pass?.value === "d_pass",
      then: Yup.mixed().required(
        "Marriage Certificate/birth Certificate is required"
      ),
    }),
  });

  // handle File Upload
  const handleFileUpload = (fieldName, setFieldValue) => (e) => {
    const file = e?.target?.files[0];
    const type = file?.type;
    const formData = new FormData();
    formData.append("type", "service-request");
    formData.append("file", file);
    formData.append(
      "document_type",
      type === "application/pdf" ? "doc" : "img"
    );

    dispatch(uploadFile(formData)).then((res) => {
      if (res.type === "uploadFile/fulfilled") {
        setFieldValue(fieldName, res.payload.data);
      }
    });
  };

  // Proceed with request
  const handleSubmit = (values) => {
    const payload = {
      details: {
        ...(values.marriage_birth_certificate && {
          marriage_birth_certificate: values.marriage_birth_certificate?.url,
        }),
        ic_front: values.ic_front?.url,
        ic_back: values.ic_back?.url,
        type_of_pass: values?.type_of_pass?.value,
        education_certificate: values?.education_certificate?.url,
        passport: values?.passport?.url,
        resume: values?.resume?.url,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };

    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0 ||
        detail?.price === undefined
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <div className="space-y-2 font-ebGaramond">
          <p className="text-xl">We see that you will need a request on:</p>
          <p className="text-3xl">Applying for passes</p>
        </div>
      </div>
      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <Formik
        initialValues={{
          type_of_pass: "",
          passport: null,
          ic_front: null,
          ic_back: null,
          resume: null,
          education_certificate: null,
          marriage_birth_certificate: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="space-y-5">
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="text-2xl font-ebGaramond">
                Let us know what type of passes you need
              </p>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>1.</span>
                <p>How many new local director are you appointing?</p>
              </div>
              <p className="text-sm">
                Select the type of pass you need us to handle and process
              </p>
              <ReactSelect
                className={"p-0"}
                id="type_of_pass"
                placeholder="Type of Pass"
                options={[
                  { value: "employment_pass", label: "Employment Pass" },
                  { value: "d_pass", label: "D Pass" },
                ]}
                isLoading={false}
                value={values.type_of_pass}
                isClearable
                onChange={(option) => {
                  setFieldValue("type_of_pass", option);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid ${
                      errors.type_of_pass && touched.type_of_pass
                        ? "red"
                        : "#0000003B"
                    }`,
                    borderRadius: "0.3rem",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #cdddeb",
                    },
                  }),
                }}
              />
              {errors.type_of_pass && touched.type_of_pass ? (
                <InputError errorTitle={errors.type_of_pass} />
              ) : null}

              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>2.</span>
                <p>Provide us with the hire particulars</p>
              </div>
              {values.type_of_pass && (
                <>
                  <p className="text-sm">i. IC</p>
                  <li className="text-sm">IC front</li>
                  {/* Upload IC front */}
                  <div>
                    {values?.ic_front ? (
                      <FileView
                        document_type={values?.ic_front?.document_type}
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.ic_front?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={errors.ic_front && touched.ic_front}
                        name="ic_front"
                        handleFileChange={handleFileUpload(
                          "ic_front",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.ic_front && touched.ic_front ? (
                      <InputError errorTitle={errors.ic_front} />
                    ) : null}
                  </div>
                  <li className="text-sm">IC back</li>
                  {/* Upload IC back */}
                  <div>
                    {values?.ic_back ? (
                      <FileView
                        document_type={values?.ic_back?.document_type}
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.ic_back?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={errors.ic_back && touched.ic_back}
                        name="ic_back"
                        handleFileChange={handleFileUpload(
                          "ic_back",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.ic_back && touched.ic_back ? (
                      <InputError errorTitle={errors.ic_back} />
                    ) : null}
                  </div>
                  <p className="text-sm">ii. Passport</p>
                  {/* Upload Passport */}
                  <div>
                    {values?.passport ? (
                      <FileView
                        document_type={values?.passport?.document_type}
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.passport?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={errors.passport && touched.passport}
                        name="passport"
                        handleFileChange={handleFileUpload(
                          "passport",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.passport && touched.passport ? (
                      <InputError errorTitle={errors.passport} />
                    ) : null}
                  </div>
                  <p className="text-sm">iii. Resume</p>
                  {/* Upload Resume */}
                  <div>
                    {values?.resume ? (
                      <FileView
                        document_type={values?.resume?.document_type}
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.resume?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={errors.resume && touched.resume}
                        name="resume"
                        handleFileChange={handleFileUpload(
                          "resume",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.resume && touched.resume ? (
                      <InputError errorTitle={errors.resume} />
                    ) : null}
                  </div>
                  <p className="text-sm">iv. Education Certificate</p>
                  {/* Upload Education Certificate */}
                  <div>
                    {values?.education_certificate ? (
                      <FileView
                        document_type={
                          values?.education_certificate?.document_type
                        }
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.education_certificate?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={
                          errors.education_certificate &&
                          touched.education_certificate
                        }
                        name="education_certificate"
                        handleFileChange={handleFileUpload(
                          "education_certificate",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.education_certificate &&
                    touched.education_certificate ? (
                      <InputError errorTitle={errors.education_certificate} />
                    ) : null}
                  </div>
                </>
              )}

              {values.type_of_pass?.value === "d_pass" && (
                <>
                  <p className="text-sm">
                    v. Marriage Certificate/birth certificate
                  </p>
                  {/* Marriage Certificate/birth certificate */}
                  <div>
                    {values?.marriage_birth_certificate ? (
                      <FileView
                        document_type={
                          values?.marriage_birth_certificate?.document_type
                        }
                        onClose={() => setFieldValue("proof_of_address", null)}
                        url={values?.marriage_birth_certificate?.url}
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={
                          errors.marriage_birth_certificate &&
                          touched.marriage_birth_certificate
                        }
                        name="marriage_birth_certificate"
                        handleFileChange={handleFileUpload(
                          "marriage_birth_certificate",
                          setFieldValue
                        )}
                      />
                    )}
                    {errors.marriage_birth_certificate &&
                    touched.marriage_birth_certificate ? (
                      <InputError
                        errorTitle={errors.marriage_birth_certificate}
                      />
                    ) : null}
                  </div>
                </>
              )}

              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>3.</span>
                <p>Obtain required documents if needed</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>4.</span>
                <p>We will submit it to the MOM for final approval</p>
              </div>
              <p className="text-sm">
                Once the request is opened. You can easily manage it over at
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">Total</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? service?.detail?.price
                    : "Free"}
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between space-x-1 rounded-lg px-4 py-3 shadow-lg border">
              <button
                type="submit"
                className={`${
                  createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                }  uppercase`}
                disabled={createServicesRequestLoading}
              >
                {createServicesRequestLoading
                  ? "Loading.."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Amount:</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default ApplyingForPasses;
